module.exports = __webpack_public_path__ + "img/table-title-companies.932157d1.svg";